import React, { useEffect, useRef } from 'react';
import mermaid from 'mermaid';

const CoinArchitecture: React.FC = () => {
  const mermaidRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Mermaid 초기화
    mermaid.initialize({
      startOnLoad: true,
      theme: 'dark',
      themeVariables: {
        primaryColor: '#86efac',
        primaryTextColor: '#161616',
        primaryBorderColor: '#93c5fd',
        lineColor: '#f9a8d4',
        secondaryColor: '#262626',
        tertiaryColor: '#333333',
        background: '#1a1a1a',
        mainBkg: '#262626',
        secondBkg: '#2a2a2a',
        textColor: '#ffffff',
        secondaryTextColor: '#cccccc',
        tertiaryTextColor: '#888888',
      },
    });

    const mermaidDiagram = `graph TB
    subgraph "External Services"
        Upbit[Upbit WebSocket API]
        MySQL[(MySQL<br/>upbit_ticker)]
    end

    subgraph "Backend Services"
        MercuryCrypto[mercury-crypto<br/>:8082]
        MercuryBackend[mercury-backend<br/>:8080]
    end

    subgraph "Data Storage"
        Redis[(Redis)]
        RedisStream[upbit:stream:ticker:*<br/>실시간 데이터]
        RedisBT[bt:upbit:ticker:*:*<br/>백테스트 데이터]
    end

    subgraph "Frontend"
        ReactApp[React App]
        RTCharts[실시간 차트<br/>RTUpbitChart]
        BTCharts[백테스트 차트<br/>BTCoinBacktest]
    end

    Upbit -->|WebSocket| MercuryCrypto
    MercuryCrypto -->|저장| RedisStream
    RedisStream -->|WebSocket/HTTP| ReactApp
    ReactApp --> RTCharts

    MySQL -->|데이터 임포트| MercuryBackend
    MercuryBackend -->|저장| RedisBT
    RedisBT -->|HTTP API| ReactApp
    ReactApp --> BTCharts

    ReactApp -->|/mercury-backend/bt/coin-list| MercuryBackend
    ReactApp -->|/mercury-backend/bt/coin-backtest| MercuryBackend
    ReactApp -->|/mercury-backend/bt/import-data| MercuryBackend
    ReactApp -->|/mercury-crypto/rt-upbit-ticker| MercuryCrypto

    style Upbit fill:#86efac,stroke:#93c5fd,stroke-width:2px,color:#161616
    style MySQL fill:#86efac,stroke:#93c5fd,stroke-width:2px,color:#161616
    style MercuryCrypto fill:#93c5fd,stroke:#f9a8d4,stroke-width:2px,color:#161616
    style MercuryBackend fill:#93c5fd,stroke:#f9a8d4,stroke-width:2px,color:#161616
    style Redis fill:#f9a8d4,stroke:#86efac,stroke-width:2px,color:#161616
    style ReactApp fill:#86efac,stroke:#93c5fd,stroke-width:2px,color:#161616
    style RTCharts fill:#262626,stroke:#444,stroke-width:1px,color:#ffffff
    style BTCharts fill:#262626,stroke:#444,stroke-width:1px,color:#ffffff`;

    if (mermaidRef.current) {
      mermaidRef.current.className = 'mermaid';
      mermaidRef.current.textContent = mermaidDiagram;
      mermaid.contentLoaded();
    }
  }, []);

  return (
    <div style={{ 
      background: '#1a1a1a', 
      border: '1px solid #444', 
      borderRadius: '8px', 
      padding: '20px',
      overflow: 'auto'
    }}>
      <h3 style={{ color: '#ffffff', marginBottom: '20px', fontSize: '18px' }}>코인 시스템 아키텍처</h3>
      <div ref={mermaidRef} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
    </div>
  );
};

export default CoinArchitecture;

